import * as templatePolyfill from 'template-polyfill'

export default class TooltipsHandler {
  constructor(private container: HTMLElement) {
    templatePolyfill()
  }

  public handle(event: Event) {
    event.stopPropagation()

    const wordLink = event.target as HTMLElement
    if (!wordLink.classList.contains('word-link')) {
      return
    }

    const wordLinksExceptSelf = this.container.querySelectorAll(
      `.word-link.with-tooltip:not([data-uid="${wordLink.dataset.uid}"])`
    )

    wordLink.querySelector('dl[data-tooltip]')
      ? this.toggle(wordLink)
      : this.create(wordLink)
    this.removeAll(wordLinksExceptSelf)
  }

  public removeAll(
    tooltips = this.container.querySelectorAll('.word-link.with-tooltip')
  ) {
    tooltips.forEach(wordLink => wordLink.classList.remove('with-tooltip'))
  }

  private toggle(wordLink: HTMLElement) {
    wordLink.classList.toggle('with-tooltip')
  }

  private create(wordLink: HTMLElement) {
    const template: HTMLTemplateElement = document.querySelector(
      `template[data-tooltip=${wordLink.dataset.tooltip}]`
    )
    const clone = document.importNode(template.content, true)
    const dataUID = this.container.querySelectorAll('.word-link dl').length
    const wordLinksWithTooltip = this.container.querySelectorAll(
      '.word-link.with-tooltip'
    )
    wordLinksWithTooltip.forEach((wordLinkWithTooltip: HTMLElement) => {
      this.toggle(wordLinkWithTooltip)
    })

    wordLink.setAttribute('data-uid', `${dataUID}`)
    wordLink.classList.add('with-tooltip')
    wordLink.appendChild(clone.firstChild)
    this.adjustPosition(wordLink)
  }

  private adjustPosition(wordLink: HTMLElement) {
    const wordLinkLeft = wordLink.offsetLeft
    const wordLinkWidth = wordLink.getClientRects()[0].width
    const containerWidth = this.container.getBoundingClientRect().width
    const tooltip = wordLink.querySelector('dl')
    const tooltipWidth = tooltip.getBoundingClientRect().width
    const tooltipHeight = tooltip.getBoundingClientRect().height

    // ポップアップが移動できるのは親要素から自身の幅を引いた範囲だけ。それ以上は丸められる。
    const max = containerWidth - tooltipWidth
    const rawOffsetLeft = wordLinkLeft + wordLinkWidth / 2 - tooltipWidth / 2
    const clampedOffsetLeft = this.clamp(rawOffsetLeft, 0, max)

    tooltip.style.left = `${this.clamp(clampedOffsetLeft, 0, max)}px`
    tooltip.style.marginBottom = `${(wordLink.offsetTop - 20) * -1}px`
    tooltip.style.height = `${tooltipHeight}px`

    const arrow: HTMLElement = wordLink.querySelector('.arrow')
    const arrowOffsetLeft = wordLinkLeft + wordLinkWidth / 2 - clampedOffsetLeft
    arrow.style.left = `${arrowOffsetLeft}px`
  }

  private clamp(target: number, min: number, max: number) {
    return Math.max(Math.min(max, target), min)
  }
}
